/**
 * @file APP增流上报
 */
export default function () {
    try {
        let _maq = _maq || []
        const userAgent = window.navigator.userAgent
        const android = userAgent.match(/(Android)[\s\/]*([\d\.]+)/i)
        const ios = userAgent.match(/(iPad|iPhone|iPod)[\w\s]*;(?:[\w\s]+;)*[\w\s]+(?:iPad|iPhone|iPod)?\sOS\s([\d_\.]+)/i)
        const platform = android ? "android" : ios ? "ios" : ""
        _maq.push(
            ["account", "sohunews"],
            ["channel", ""],
            ["point", ""],
            ["platform", platform]
        )
        const ma = document.createElement("script")
        ma.type = "text/javascript"
        ma.async = true
        ma.src =
            ("https:" == document.location.protocol ? "https://" : "http://") +
            "www.qchannel03.cn/m2.js?w=" +
            _maq[0][1]
        const s = document.getElementsByTagName("script")[0]
        s.parentNode.insertBefore(ma, s)
    } catch (error) {
        console.log('app增流上报出错', error)
    }
}
